@if (hasMultipleTenants() || isLoading()) {
  <app-multi-select
    type="single"
    [options]="tenantOptions()"
    [ngModel]="selectedTenant()"
    (ngModelChange)="onTenantChange($event)"
    [isLoading]="isLoading()"
    [withSearch]="true"
    [customPositions]="positions"
    dropdownClasses="min-w-[300px]"
    optionsContainerClasses="[&&]:max-h-[168px]"
  >
    <button
      *appMultiSelectCustomTrigger
      type="button"
      [disabled]="isLoading()"
      class="flex items-center p-2 rounded-radius-circle bg-background-fixed"
    >
      <svg-icon class="text-action-primary" key="chevron-down-16" size="16" />
    </button>
  </app-multi-select>
}
